import {
    ICurrentFocusLevel, IFamilyTreeNode,
    IFamilyTreeTrail, ITrailHistory, ITrailLevelChangeHistory
} from 'src/app/common/models/IFamilyTreeTrail';

export class SetFamilyTrailData {
    static readonly type = '[IFamilyTrail] Set FamilyTrail Data';

    constructor(public familyTrail: IFamilyTreeTrail[]) { }
}

export class SetFocusedTrailData {
    static readonly type = '[IFocusedTrail] Set FocusedTrail Data';

    constructor(public focusedTrail: IFamilyTreeTrail) { }
}

export class SetFamilyTreeNodeData {
    static readonly type = '[IFamilyTreeNode] Set FamilyTreeNode Data';

    constructor(public data: IFamilyTreeNode) { }
}

export class SetFamilyVisitedProfile {
    static readonly type = '[IFamilyVisitedProfile] Set FamilyVisitedProfile Data';

    constructor(public visitedProfile: boolean) { }
}

export class SetFamilyView {
    static readonly type = '[IFamilySelectedView] Set FamilyView Data';

    constructor(public familyView: number) { }
}

export class SetTrailHistory {
    static readonly type = '[ITrailHistory] Set TrailHistory Data';

    constructor(public trailHistory: ITrailHistory) { }
}

export class SetTrailLevelChangeHistory {
    static readonly type = '[ITrailLevelChangeHistory] Set TrailLevelChangeHistory Data';

    constructor(public trailLevelChangeHistory: ITrailLevelChangeHistory) { }
}

export class SetCurrentFocusLevel {
    static readonly type = '[ICurrentFocusLevel] Set CurrentFocusLevel Data';

    constructor(public currentFocusLevel: ICurrentFocusLevel) { }
}

export class SetCreateUpdate {
    static readonly type = '[ICreateUpdate] Set CreateUpdate Data';

    constructor(public createUpdate: string) { }
}

export class ResetFamilyTrailData {
    static readonly type = '[Reset] family history State';

    constructor() { }
}

export class ClearFamilyTrailData {
    static readonly type = '[Settings] Clear Settings State Family Tree';

    constructor() { }
}
